import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const Anchors = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  pointer-events: none;
  display: ${props => props.visible ? 'block' : 'none'}
`
const Anchor = styled.div`
  position: absolute;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  ${props => props.top ? 'top: -5px;' : ''}
  ${props => props.left ? 'left: -5px;' : ''}
  ${props => props.bottom ? 'bottom: -5px;' : ''}
  ${props => props.right ? 'right: -5px;' : ''}
  ${props => props.horizontalCenter ? 'left: calc(50% - 5px);' : ''}
  ${props => props.verticalCenter ? 'top: calc(50% - 5px);' : ''}
  background-color: #fff;
`
const ResizeAnchors = (props) => (
  <Anchors visible={props.visible}>
    <Anchor top left />
    <Anchor top right />
    <Anchor bottom left />
    <Anchor bottom right />
    <Anchor top horizontalCenter />
    <Anchor bottom horizontalCenter />
    <Anchor left verticalCenter />
    <Anchor right verticalCenter />
  </Anchors>
)

ResizeAnchors.propTypes = {
  visible: PropTypes.bool
}

export default ResizeAnchors



// WEBPACK FOOTER //
// ./src/components/shared/ResizeAnchors.js